// Required
import '@sentry/tracing'

import { createUploadLink } from 'apollo-upload-client'
import { type IncomingHttpHeaders } from 'http'

import { logger } from '@/utils/sendToLogger'

/// Temp, until we figure out how to make requests work with dev:ssl using Next Rewrites
const useAnvilDirectly = process.env.NEXT_PUBLIC_DEV_SSL === 'true'

const uploadLink = (headers: IncomingHttpHeaders, isServer?: boolean) => {
  const url = isServer
    ? `${process.env.NEXT_PUBLIC_SERVER_ANVIL_URL}/api`
    : useAnvilDirectly
    ? `${process.env.NEXT_PUBLIC_CLIENT_ANVIL_URL}/api`
    : `${process.env.NEXT_PUBLIC_WEBAPP_URL}/anvil2/api`

  const enhancedFetch: WindowOrWorkerGlobalScope['fetch'] = async (url, init) => {
    let operationName = 'Unknown'
    if (init?.body && typeof init.body === 'string') {
      operationName = JSON.parse(init?.body).operationName
    }
    const transaction = logger.startTransaction({ name: 'GraphQLFetch' })
    const span = transaction.startChild({ op: operationName })

    const result = await fetch(url, {
      ...init,
      headers: {
        ...init?.headers,
        Cookie: headers?.cookie ?? '',
        origin: process.env.NEXT_PUBLIC_WEBAPP_URL ?? '',
      },
    })

    span.finish()
    transaction.finish()

    return result
  }

  return createUploadLink({
    uri: url,
    credentials: 'include',
    fetch: enhancedFetch,
    headers: {
      'Apollo-Require-Preflight': 'true',
    },
  })
}

export default uploadLink
